<template>
  <div id="home">
    <app-slider></app-slider>
    <app-navigation></app-navigation>
    <app-random-archives></app-random-archives>
  </div>
</template>
<script>
  import Slider from './Slider.vue'
  import Navigation from './Navigation.vue'
  import RandomArchives from './RandomArchives.vue'

  export default {
    components: {
      appSlider: Slider,
      appNavigation: Navigation,
      appRandomArchives: RandomArchives
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Home.vue?1e40f74e